// extracted by mini-css-extract-plugin
module.exports = {"formAdminLogin":"admin-login_formAdminLogin__1UxB6","inputText":"admin-login_inputText__3jdYW","marginBottom":"admin-login_marginBottom__1yqGG"};